
<section
  ref="carousel"
  class="l-carousel"
>
  <div class="l-carousel__slides">
    <figure
      v-for="slide in slides"
      :key="slide.id"
      class="l-carousel__item l-figure"
    >
      <img
        class="l-carousel__item-image"
        :src="slide.image.normal"
        :srcset="`
          ${slide.image.normal},
          ${slide.image.retina} 2x
        `"
        :alt="slide.alt"
      >
    </figure>
  </div>
</section>
